import { useThemeContext } from '../../../../contexts/ThemeContext';
import { resolveColor } from '../../theme/utils/resolveColor';
import { PoweredByQITech } from '../components/PoweredByQITech';
import * as S from './styles';

interface LendingReprovedProps {
    signData?: any;
}

export const PrivatePayrollAuctionLendingReproved = ({ signData }: LendingReprovedProps) => {
    const { clientThemeSettings } = useThemeContext();

    if (!clientThemeSettings) return <></>;

    const primary = resolveColor('primary', clientThemeSettings);
    const reproved = signData?.signature_settings?.lending_analysis_content?.reproved;

    return (
        <S.PageWrapper>
            <S.LogoSection>
                {clientThemeSettings.logo_url && (
                    <S.LogoImage src={clientThemeSettings.logo_url} alt="logo" />
                )}
            </S.LogoSection>

            <S.Content>
                <S.IconWrapper $color={primary}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="6" y1="6" x2="18" y2="18" />
                        <line x1="18" y1="6" x2="6" y2="18" />
                    </svg>
                </S.IconWrapper>
                <S.Title $color={primary}>
                    {reproved?.title ?? 'Recebemos sua proposta mas não pudemos dar continuidade'}
                </S.Title>
            </S.Content>

            <S.Footer>
                <PoweredByQITech />
            </S.Footer>
        </S.PageWrapper>
    );
};
